import type { Position } from '../types/position'

/** Position API prices are canonical per-share quotes, including fractional-cent fills. */
export function formatOptionPremium(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(value)
}

/** Keep conventional cents for inputs without rounding fractional-cent broker fills. */
export function optionPremiumInput(value: number): string {
  const cents = value.toFixed(2)
  return Number(cents) === value ? cents : String(value)
}

/** Legacy manual positions use standard contracts; verified provider terms take precedence. */
export function optionContractMultiplier(position: Pick<Position, 'contract_multiplier'>): number {
  const multiplier = position.contract_multiplier
  return typeof multiplier === 'number' && Number.isFinite(multiplier) && multiplier > 0
    ? multiplier
    : 100
}

/** Convert a canonical quote to total cash value exactly once. */
export function optionPositionValue(
  position: Pick<Position, 'quantity' | 'contract_multiplier'>,
  premiumPerShare: number
): number {
  return premiumPerShare * optionContractMultiplier(position) * Math.abs(position.quantity)
}
